import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  datePicker: {
    width: "240px",
    "& .MuiInputBase-root": {
      height: "40px",
      padding: 0,
    },
    "& .MuiInputBase-input": {
      height: "100%",
      lineHeight: "40px",
      padding: "0 14px",
      boxSizing: "border-box",
    },
  },
}));
